export const MODELS_FILTERS = {
    filters: [
        {
            name: 'WorkingOn',
            label: 'Working On',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: 'period',
            type: 'period',
        },
        {
            name: 'NotWorkingOn',
            label: 'NOT working On',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: 'period',
            type: 'period',
        },
        {
            name: 'Booker',
            label: 'Booker',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: 'booker',
            type: 'booker-selector',
        },
        {
            name: 'Scouter',
            label: 'Scouter',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: 'booker',
            type: 'booker-selector',
        },
        {
            name: 'Departments',
            label: 'Departments',
            area: 'work',
            areaIndex: 1,
            defaultval: [],
            commontype: null,
            type: 'departments-selector-multi',
        },
        {
            name: 'Tags',
            label: 'Tags',
            area: 'work',
            areaIndex: 1,
            defaultval: [],
            commontype: 'tag',
            type: 'models-tag',
        },
        {
            name: 'AddedSince',
            label: 'Added Since',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: 'date',
            type: 'date',
        },
        {
            name: 'AddedUntil',
            label: 'Added Until',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: 'date',
            type: 'date',
        },
        {
            name: 'InTown',
            label: 'In Town',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: null,
            type: 'intown-selector',
        },
        {
            name: 'Documents',
            label: 'Pictures and videos',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: null,
            type: 'document-filter',
        },
        {
            name: 'Playlist',
            label: 'Playlists',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: null,
            type: 'playlist-filter',
        },
        {
            name: 'Published',
            label: 'Published playlists',
            area: 'work',
            areaIndex: 1,
            defaultval: null,
            commontype: null,
            type: 'published-filter',
        },
        //array vuoto = "in almeno una folder" / "in nessuna folder", array di ID = folder specifiche
        {
            name: 'WithFolders',
            label: 'In folders',
            area: 'folders',
            areaIndex: 2,
            defaultval: null,
            commontype: 'array',
            type: 'folders-selector',
        },
        {
            name: 'WithoutFolders',
            label: 'Not in folders',
            area: 'folders',
            areaIndex: 2,
            defaultval: null,
            commontype: 'array',
            type: 'folders-selector',
        },
        {
            name: 'AgencyID',
            label: 'Working with agency',
            area: 'agency',
            areaIndex: 2,
            defaultval: null,
            commontype: null,
            type: 'agency-selector',
        },
        {
            name: 'AgencyType',
            label: 'as:',
            description: 'agency relationship type',
            area: 'agency',
            areaIndex: 2,
            defaultval: null,
            commontype: null,
            type: 'agency-type-selector',
        },
        {
            name: 'AgencyNotIn',
            label: 'exclude condition',
            area: 'agency',
            areaIndex: 2,
            defaultval: null,
            commontype: null,
            type: 'boolean',
        },
        {
            name: 'AgencyCities',
            label: 'cities',
            area: 'agency',
            areaIndex: 2,
            defaultval: [],
            commontype: 'array',
            type: 'cities-selector',
        },
        {
            name: 'AgencyCountry',
            label: 'country',
            area: 'agency',
            areaIndex: 2,
            defaultval: null,
            commontype: null,
            type: 'country-selector',
        },
        {
            name: 'AgencyIncludeDropped',
            label: 'Include Dropped',
            area: 'agency',
            areaIndex: 2,
            defaultval: null,
            commontype: null,
            type: 'boolean',
        },
        {
            name: 'Represented',
            label: 'Represented',
            area: 'agency',
            areaIndex: 2,
            defaultval: null,
            commontype: null,
            type: 'boolean',
        },
        {
            name: 'AgeRange',
            label: 'Age',
            area: 'demographic',
            areaIndex: 3,
            defaultval: [null, null],
            commontype: null,
            type: 'age-range',
        },
        // {
        //     name: 'AgeSince',
        //     label: 'Age - From',
        //     area: 'demographic',
        //     areaIndex: 3,
        //     defaultval: null,
        //     commontype: null,
        //     type: 'number',
        // },
        // {
        //     name: 'AgeUntil',
        //     label: 'Age - To',
        //     description: 'inclusive',
        //     area: 'demographic',
        //     areaIndex: 3,
        //     defaultval: null,
        //     commontype: null,
        //     type: 'number',
        // },

        {
            name: 'Nationalities',
            label: 'Nationality',
            area: 'demographic',
            areaIndex: 3,
            defaultval: [],
            commontype: 'array',
            type: 'countries-selector',
        },
        {
            name: 'Citizenships',
            label: 'Citizenship',
            area: 'demographic',
            areaIndex: 3,
            defaultval: [],
            commontype: 'array',
            type: 'countries-selector',
        },
        {
            name: 'Gender',
            label: 'Gender',
            area: 'demographic',
            areaIndex: 3,
            defaultval: null,
            commontype: null,
            type: 'gender',
        },
        {
            name: 'Countries',
            label: 'Country',
            description: '',
            area: 'demographic',
            areaIndex: 3,
            defaultval: [],
            commontype: 'array',
            type: 'countries-selector',
        },
        {
            name: 'Cities',
            label: 'City',
            description: '',
            area: 'demographic',
            areaIndex: 3,
            defaultval: [],
            commontype: 'array',
            type: 'cities-selector',
        },
        {
            name: 'State',
            label: 'State',
            description: '',
            area: 'demographic',
            areaIndex: 3,
            defaultval: null,
            commontype: null,
            type: 'text',
        },
        {
            name: 'County',
            label: 'County',
            description: '',
            area: 'demographic',
            areaIndex: 3,
            defaultval: null,
            commontype: null,
            type: 'text',
        },
        {
            name: 'Email',
            label: 'E-mail address',
            description: '',
            area: 'demographic',
            areaIndex: 3,
            defaultval: null,
            commontype: null,
            type: 'text',
        },
        {
            name: 'Phone',
            label: 'Phone number',
            description: '',
            area: 'demographic',
            areaIndex: 3,
            defaultval: null,
            commontype: null,
            type: 'text',
        },
    ],
};
